var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 4.49114C13.8 3.66761 13.1324 3 12.3089 3H11.4353C10.753 3 10.2 3.55304 10.2 4.23526V4.36314C10.2 5.41644 8.92651 5.94394 8.18171 5.19914C7.72 4.73743 6.97142 4.73743 6.50971 5.19914L5.76412 5.94473C5.23172 6.47713 5.23172 7.34032 5.76412 7.87272C6.62294 8.73154 6.01469 10.2 4.80013 10.2H4.49124C3.66765 10.2 3 10.8677 3 11.6912V12.3089C3 13.1324 3.66761 13.8 4.49114 13.8H4.79996C6.01446 13.8 6.62268 15.2684 5.7639 16.1272C5.23153 16.6595 5.23153 17.5227 5.7639 18.055L6.50949 18.8006C6.97123 19.2624 7.71986 19.2624 8.18159 18.8006C8.92644 18.0558 10.2 18.5833 10.2 19.6367V19.7646C10.2 20.4469 10.7531 21 11.4354 21H12.3088C13.1324 21 13.8 20.3324 13.8 19.5088C13.8 18.1802 15.4063 17.5149 16.3457 18.4543L16.4361 18.5447C17.0392 19.1478 18.0169 19.1478 18.62 18.5447L19.1097 18.055C19.6421 17.5226 19.6421 16.6595 19.1097 16.1271L18.8913 15.9087C18.1131 15.1305 18.6642 13.8 19.7647 13.8C20.447 13.8 21 13.247 21 12.5647V11.4354C21 10.7531 20.4469 10.2 19.7646 10.2C18.6641 10.2 18.1129 8.86935 18.8911 8.09112L19.1095 7.87275C19.6419 7.34036 19.6419 6.47718 19.1095 5.94479L18.6198 5.45505C18.0167 4.85203 17.039 4.85203 16.436 5.45505L16.3455 5.54553C15.4062 6.4849 13.8 5.8196 13.8 4.49114Z",
    stroke: "#007FFF",
    strokeWidth: 1.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    stroke: "#007FFF",
    strokeWidth: 1.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.64416f81.svg";
export { ForwardRef as ReactComponent };